import Choices from "choices.js";
import Swiper from "swiper";

export default class Global {

    constructor() {
        this.initChoices();
        this.initRating();
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }

    initRating() {
        if (document.getElementById('reviewWrapper')) {
            new Swiper('#reviewWrapper .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                navigation: {
                    nextEl: '#reviewWrapper .swiper-button-next',
                    prevEl: '#reviewWrapper .swiper-button-prev',
                },
            });
        }
    }
}
